import { gql } from '@apollo/client'

/**
 * gets the string for `getOrders` query
 * returns the session's own order history, newest-first, paginated
 * @internal
 */

/*
 * `items { sku }` is deliberately minimal rather than the shared
 * `cartProductsFieldsQuery` fragment that `lastOrder` selects. The user API
 * returns parent orders unenriched, so the rest of the `CartProduct` payload
 * resolves to nulls; the selection exists only so the client can count the
 * lines into `itemsCount`, a field `Order` does not carry.
 */
const getOrdersQuery = gql`
  query GetOrders(
    $storefrontName: String!
    $sessionUid: ID!
    $pagination: PaginationInput
    $filter: SessionOrderFilterInput
  ) {
    getOrders(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      pagination: $pagination
      filter: $filter
    ) {
      orders {
        id
        createdAt
        status
        total
        sequence
        items {
          sku
        }
      }
      pagination {
        total
        totalPages
        pageNumber
        pageSize
        hasNextPage
        nextPage
      }
    }
  }
`

export default getOrdersQuery
